import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { TryOnModal } from "../components/atelier/TryOnModal";
import { api } from "./api";
import { pickLocale } from "./format";

const TryOnLauncherCtx = createContext(null);

export function TryOnLauncherProvider({ children }) {
  const [payload, setPayload] = useState(null);
  const [runtimeConfig, setRuntimeConfig] = useState(null);

  useEffect(() => {
    api.get("/tryon/config")
      .then((response) => setRuntimeConfig(response.data))
      .catch(() => setRuntimeConfig({ enabled: false, provider_ready: false }));
  }, []);

  const value = useMemo(() => ({
    openTryOn: (product, options = {}) => setPayload({ product, ...options }),
    closeTryOn: () => setPayload(null),
  }), []);

  const product = payload?.product || null;

  return (
    <TryOnLauncherCtx.Provider value={value}>
      {children}
      <TryOnModal
        open={Boolean(payload)}
        onClose={() => setPayload(null)}
        productId={product?.id}
        productHandle={product?.handle}
        productTitle={pickLocale(product?.title)}
        product={product}
        selectedVariant={payload?.selectedVariant}
        currentFit={payload?.currentFit || "classic"}
        variantId={payload?.selectedVariant?.id}
        colourValueId={payload?.colourValueId}
        runtimeConfig={payload?.runtimeConfig || runtimeConfig}
        relatedProducts={payload?.relatedProducts || []}
        completeLook={payload?.completeLook || null}
      />
    </TryOnLauncherCtx.Provider>
  );
}

export function useTryOnLauncher() {
  return useContext(TryOnLauncherCtx);
}
